import { useState, useEffect } from "react";
import { getMatGroups, getMaterial } from "../services/material-services"; 


export function useFetchMaterial(type_data, matID, lang_id){
    const [Result, setData] = useState(null);
    const [error, setError] = useState(false);
    const [loading, setLoding] = useState(false);

    useEffect(() => {
        const getData = async () =>{
            setLoding(true);
            const data = await getMaterial(type_data, matID, lang_id);
            setData(data);
            setLoding(false);
            setError(false);
        }
        getData();
    }, [matID]);

    return [Result, loading, error];
}

export function useFetchShopping(user){
    const [Result, setData] = useState(null);
    const [error, setError] = useState(false);
    const [loading, setLoding] = useState(false);

    useEffect(() => {
        const getData = async () =>{
            setLoding(true);
            const data = await getMaterial(user);
            setData(data);
            setLoding(false);
            setError(false);
        }
        getData();
    }, [user]);

    return [Result, loading, error];
}


export function useFetchListGroup(lang_id, data_type){
    const [Result, setData] = useState(null);
    const [error, setError] = useState(false);
    const [loading, setLoding] = useState(false);
    var dataGroup = '';
    if(data_type)
    {
        dataGroup = `?data_type=${data_type}`;
    }
    useEffect(() => {
        const getData = async () =>{
            setLoding(true);
            const data = await getMatGroups(lang_id, dataGroup);
            setData(data);
            setLoding(false);
            setError(false);
        }
        getData();
    }, [lang_id, data_type]);

    return [Result, loading, error];
}
